import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';

type HeadingContainerProps = {
  heading: string;
};

const HeadingContainer = (props: HeadingContainerProps) => {
  const { heading } = props;
  return (
    <Typography variant={'p4'} className={styles.headerText}>
      {heading}
    </Typography>
  );
};

export default HeadingContainer;
